var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.107,0c6.112,0.005,11.276,4.83,11.727,10.957 c0.44,5.992-3.994,11.47-9.959,12.396c-2.259,0.351-4.392,0.026-6.463-0.844c-0.526-0.221-0.997-0.276-1.541-0.1 c-1.557,0.504-3.124,0.976-4.689,1.453c-0.312,0.095-0.666,0.274-0.934-0.038c-0.224-0.261-0.06-0.577,0.026-0.86 c0.448-1.47,0.874-2.947,1.367-4.401c0.222-0.656,0.131-1.196-0.158-1.81C-2.19,8.947,3.497-0.007,12.107,0z M9.411,7.445 c-1.002,0-2.004-0.021-3.006,0.006c-1.139,0.03-1.759,0.583-1.784,1.723c-0.044,2.036-0.042,4.075,0.015,6.11 c0.03,1.057,0.668,1.689,1.726,1.715c2.036,0.052,4.075,0.049,6.11,0.006c1.059-0.022,1.682-0.671,1.698-1.715 c0.032-2.037,0.035-4.075,0.004-6.111c-0.018-1.152-0.589-1.691-1.759-1.726C11.415,7.425,10.412,7.448,9.411,7.445z M19.018,12.315 c0-1.034-0.001-2.068,0-3.102c0-0.517-0.217-0.669-0.687-0.425c-0.887,0.462-1.78,0.916-2.663,1.386 c-0.417,0.223-0.582,0.593-0.621,1.067c-0.21,2.553-0.187,2.609,2.098,3.777c0.356,0.182,0.726,0.345,1.066,0.553 c0.567,0.349,0.837,0.278,0.814-0.455C18.998,14.184,19.02,13.249,19.018,12.315z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.e4871a74.svg";
export { ForwardRef as ReactComponent };